import { useEffect } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";
import GpsFixedIcon from "@mui/icons-material/GpsFixed";
import { createRoot } from "react-dom/client";

function GpsButtonControl({ onClick }: { onClick: () => void }) {
  const map = useMap();

  useEffect(() => {
    const GpsControl = L.Control.extend({
      onAdd: function () {
        const button = L.DomUtil.create("button", "");
        button.style.width = "40px";
        button.style.height = "40px";
        button.style.borderRadius = "50%";
        button.style.border = "none";
        button.style.background = "#FFF";
        button.style.color = "white";
        button.style.cursor = "pointer";
        button.style.display = "flex";
        button.style.alignItems = "center";
        button.style.justifyContent = "center";
        button.style.padding = "0";
        button.title = "Use GPS";

        // Correct way: create a div for React
        const iconContainer = L.DomUtil.create("div", "");
        button.appendChild(iconContainer); // append the container into the button

        // Create React root inside the container
        const root = createRoot(iconContainer);
        root.render(<GpsFixedIcon sx={{ color: "#162C1F" }} />);

        L.DomEvent.on(button, "click", onClick);

        return button;
      },
      onRemove: function () {},
    });

    const gpsControl = new GpsControl({ position: "topleft" });
    map.addControl(gpsControl);

    return () => {
      map.removeControl(gpsControl);
    };
  }, [map, onClick]);

  return null;
}

export default GpsButtonControl;
